import { Container } from '@cp/ds/src/components/container';
import { Box } from '@cp/ds/src/components/box';
import { PropsWithChildren } from 'react';
import { SxProps } from '@cp/ds';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';

export const StepContainer = (props: PropsWithChildren & { sx?: SxProps }) => {
  const isMobile = useIsMobile();
  return isMobile ? <Container {...props} /> : <Box {...props} />;
};
